export const ALERT_APPEARANCE = Object.freeze({alertLineColor:'#8A8D91',alertLineOpacity:40,alertLineWidth:1,alertLineStyle:2})
export function alertAppearance(settings={}) {
 return {
  color:/^#[0-9a-f]{6}$/i.test(settings.alertLineColor)?settings.alertLineColor:ALERT_APPEARANCE.alertLineColor,
  opacity:Number.isFinite(settings.alertLineOpacity)?Math.max(0,Math.min(100,settings.alertLineOpacity)):40,
  width:[1,2,3].includes(settings.alertLineWidth)?settings.alertLineWidth:1,
  style:[0,1,2].includes(settings.alertLineStyle)?settings.alertLineStyle:2,
 }
}
